import styled from '@emotion/styled'
import { Button, Modal, useModal } from 'kai-kit'
import type { ModalProps } from 'kai-kit'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { Button as RACButton } from 'react-aria-components'
import {
  PiMedalDuotone,
  PiIdentificationCardDuotone,
  PiStudentDuotone,
  PiFoldersDuotone,
} from 'react-icons/pi'
import { AddCollectionModal } from '../organism/Modal/Credential/AddCollectionModal'
import { CredTypeButton } from './CredTypeButton'
import { useCredentials } from '@/hooks/useCredentials'

type CredTypesModalProps = {
  collectionId: string
} & ModalProps

export const CredTypesModal: FC<CredTypesModalProps> = ({ collectionId, ...props }) => {
  const router = useRouter()
  const { collection } = useCredentials(collectionId)
  const { openModal, closeModal } = useModal()

  return (
    <>
      <Modal
        title='証明書のタイプを選択してください'
        width='560px'
        isDismissable
        isAction={false}
        {...props}
      >
        <ModalContent>
          <CredTypeButton
            icon={<PiMedalDuotone />}
            title='参加証明'
            description='イベントやカンファレンスなどへの参加証明'
            onPress={() => {
              closeModal(props.name)
              router.push(`/credential/add/attendance?pId=${collectionId}`)
            }}
            // style={{ flexGrow: 1, minWidth: '100px' }}
          />
          <CredTypeButton
            icon={<PiIdentificationCardDuotone />}
            title='会員証'
            description='会社やコミュニティなどへの会員証'
            onPress={() => {
              closeModal(props.name)
              router.push(`/credential/add/membership?pId=${collectionId}`)
            }}
            // style={{ flexGrow: 1, minWidth: '100px' }}
          />
          <CredTypeButton
            icon={<PiStudentDuotone />}
            title='修了証'
            description='学位や講座などの修了証明'
            onPress={() => {
              closeModal(props.name)
              router.push(`/credential/add/certificate?pId=${collectionId}`)
            }}
            // style={{ flexGrow: 1, minWidth: '100px' }}
          />
          <CredTypeButton
            icon={
              <Image
                src='/logos/1edtech_logomark.png'
                alt='オープンバッジロゴマーク'
                width={48}
                height={48}
              />
            }
            title='オープンバッジ v3'
            description='教育系証明書の国際規格に対応した証明書'
            onPress={() => {
              closeModal(props.name)
              router.push(`/credential/add/openbadge?pId=${collectionId}`)
            }}
            // style={{ flexGrow: 1, minWidth: '100px' }}
          />
          <Button
            color='subdominant'
            variant='outlined'
            startContent={<PiFoldersDuotone size={24} color='var(--kai-color-sys-subdominant)' />}
            size='lg'
            width='100%'
            onPress={() => {
              closeModal(props.name)
              openModal('addCollectionModal')
            }}
            style={{
              justifyContent: 'start',
              backgroundColor: 'var(--kai-color-sys-layer-farther)',
            }}
          >
            コレクションを作成
          </Button>
        </ModalContent>
      </Modal>
      <AddCollectionModal
        modalName='addCollectionModal'
        parentId={collectionId}
        credentialType={collection?.credentialType}
      />
    </>
  )
}

const ModalContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--kai-size-sys-space-md);
  padding: var(--kai-size-sys-space-lg) 0;
`
